import Tabs from '@/components/Tabs/Tabs';
import './Setting.less';
import { useEffect, useState } from 'react';
import signoutIcon from '@/assets/setting/signout.png';
import avatarIcon from '@/assets/headimg.png';

import { useNavigate } from 'react-router-dom';
import { projectController } from '@/api';
import { useSelector } from 'react-redux';

export default function Home() {
  const navigate = useNavigate();

  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    query();
  }, []);

  const query = async () => {
    const res = await projectController.list({
      pageIndex: pageIndex,
      pageSize: pageSize,
      type: type,
    });
    if (res.code == 0) {
      setList(res.data.records);
    }
  };

  const clickProject = (item) => {
    if (item.type === 0) {
      navigate('/texture/' + item.id);
    }
  };

  return (
    <div className="settings-home">
      <div className="settings-container">
        <div className="settings">Settings</div>
        <div className="profile">Profile</div>
        <div className="info">
          <div className="avatar">
            <img src={avatarIcon}></img>
          </div>
          <div className="user-infos">
            <div className="nickname">{userInfo.username}</div>
            <div className="email">{userInfo.email}</div>
          </div>
        </div>
        <div className="free">
          <div className="tip">Feel free to give us feedback</div>
          <div className="contact-us">Contact Us</div>
        </div>
        <div className="sign-out">
          <span>Sign out</span>
          <img src={signoutIcon}></img>
        </div>
      </div>
    </div>
  );
}
